module.exports = __webpack_public_path__ + "media/images/Merge2-a5613e4849136eb70aab6c3d13b1dfcd.svg";